import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Permission } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from '../../../services/sx-error.service';


@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getPermissions(): Observable<Permission[]> {
    return this.http
      .get<Permission[]>(`${environment.apiEndpoint}/Configurations/Permissions`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
